module.exports = __webpack_public_path__ + "img/temperature-red.d424c557.svg";